/** Persisted open state of /clu's chat history rail. */
export const HISTORY_OPEN_KEY = 'copilot-history-rail-open';

/** Asks a mounted /clu to open its chat history rail. */
export const SHOW_CHAT_HISTORY_EVENT = 'cleanlist:show-chat-history';

/**
 * Opens /clu's chat history rail: saved open for the next landing there,
 * and opened in place when /clu is already on screen. The caller then
 * navigates to /clu.
 */
export function requestChatHistoryRail(): void {
  try {
    localStorage.setItem(HISTORY_OPEN_KEY, 'true');
  } catch {
    // Best effort: the rail falls back to its saved state.
  }
  window.dispatchEvent(new Event(SHOW_CHAT_HISTORY_EVENT));
}
